import React from "react";
import Api from "../../../Services/Api";
import {service} from "./service";
import { MutasiBarangStatus } from "../../common/Constants";

export const tableColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            setCellProps: () => ({
                style: {width: "5%"},
            }),
        },
    },
    {
        name: "mutationNo",
        label: "No. Mutasi",
    },
    {
        name: "mutationDate",
        label: "Tgl. Mutasi",
    },
    {
        name: "nameSourceKodeCabang",
        label: "Asal",
    },
    {
        name: "mutationSourceKodeLocator",
        label: "Loc. Asal",
    },
    {
        name: "nameTargetKodeCabang",
        label: "Tujuan",
    },
    {
        name: "mutationTargetKodeLocator",
        label: "Loc. Tujuan",
    },
    {
        name: "qty",
        label: "Qty",
    },
    {
        name: "mutationStatus",
        label: "Status",
    },
];

export const TABS = {
    mutasiKeluar: {
        name: "mutasiKeluar",
        getAll: (body, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").getAllMutation, setError, body),
        getById: (id, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").getMutationById, setError, id),
        delete: (id, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").deleteMutation, setError, id),
        create: (body, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").createMutation, setError, body),
        update: (body, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").submitProcessMutationOut, setError, body),
    },
    mutasiMasuk: {
        name: "mutasiMasuk",
        // findAll: "",
        getAll: (body, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").getAllMutation, setError, body),
        getById: (id, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").getMutationById, setError, id),
        delete: (id, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").deleteMutation, setError, id),
        create: (body, setError) => service.callApi(Api.create("NAGAMAS_TRANSACTION").submitMutation, setError, body),
    },
};

export const getMutasiStatusOptions = (mutasiKeluarTab) => {
  if (mutasiKeluarTab) {
    return [
      {
        label: MutasiBarangStatus.NEW,
        value: MutasiBarangStatus.NEW,
      },
      {
        label: MutasiBarangStatus.WAITING_APPROVAL,
        value: MutasiBarangStatus.WAITING_APPROVAL,
      },
      {
        label: MutasiBarangStatus.REJECTED_APPROVAL,
        value: MutasiBarangStatus.REJECTED_APPROVAL,
      },
      {
        label: MutasiBarangStatus.PROCESSED,
        value: MutasiBarangStatus.PROCESSED,
      },
    ];
  }

  return [
    {
      label: MutasiBarangStatus.PROCESSED,
      value: MutasiBarangStatus.PROCESSED,
    },
    {
      label: MutasiBarangStatus.REJECTED,
      value: MutasiBarangStatus.REJECTED,
    },
    {
      label: MutasiBarangStatus.PARTIALLY_RECEIVED,
      value: MutasiBarangStatus.PARTIALLY_RECEIVED,
    },
    {
      label: MutasiBarangStatus.RECEIVED,
      value: MutasiBarangStatus.RECEIVED,
    },
    {
      label: MutasiBarangStatus.REJECT_APPROVE,
      value: MutasiBarangStatus.REJECT_APPROVE,
    },
    {
      label: MutasiBarangStatus.WAITING_VERIFICATION,
      value: MutasiBarangStatus.WAITING_VERIFICATION,
    },
  ];
};

